import React, { Component } from 'react';
import PageTitle from "../../Components/PageTitle";
import { TextBox, SubmitBtn, SubmitButton, IconButton } from "../../Components/InputElements";
import axios from 'axios';
import Swal from 'sweetalert2';
import withRouter from '../../Utils/withRouter';
import { ConfigContext } from '../../Context/ConfigContext'
import { currentDateAndTime, decodeData } from '../../Constants/constants';
import { NoRecords } from '../../Components/Shimmer';
class EmployeeCategory extends Component {
    static contextType = ConfigContext;
    constructor(props) {
        super(props);
        this.state = {
            company_employee_category_id: 0,
            keyword: '',
            company_employee_category: '',
            rows: [],
            errors: {},
            next: false,
            prev: false,
            page: 1,
            limit: 10,
            total_records: 0,
            total_pages: 0,
            loadingList: false,
            postLoading: false,
            loadingDelete: false,
            decodedData: [],
            isCategoryModal: false,

        };
    }
    componentDidMount() {
        this.setState({ loadingList: true }, (prevState) => {
            this.GetList();
        })
    }
    componentDidUpdate(prevProps, prevState) {
          if (prevState.permissions !== this.context.permissions) {
            // console.log("Permissions Updated:", this.context.permissions);
              const { permissions } = this.context;
              if (permissions.length > 0) {
                const queryParams = new URLSearchParams(window.location.search);
                const encodedData = queryParams.get("abs");
                const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
                if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
                  this.setState({ decodedData });
                }
              } else {
                console.warn("Permissions not yet available. Retrying...");
              }
          }
      }
    handleInputChange = (e) => {
        const { name, value } = e.target;
        this.setState((prevState) => ({
            [name]: value,
            errors: {
                ...prevState.errors,
                [name]: '',
            },
        }),()=>{
            if(name === "keyword" && !value) this.GetList();
        });
    };

    GetInfo = (row) => {
        this.setState(
            {
                isCategoryModal: true,
                company_employee_category_id: row.company_employee_category_id,
                company_employee_category: row.company_employee_category,
                errors:{
                    ...this.state.errors,
                    company_employee_category: '',
                }
            }
        )
    }
    GetList = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Masters/GetEmployeeCategories`, { params: { keyword: this.state.keyword, limit: this.state.limit || 10, page: this.state.page || 1 }, headers }).then((response) => {
            var data = response.data;
            if (response.data.success === true) {
                this.setState({
                    rows: data.data,
                    next: data.next,
                    prev: data.prev,
                    page: data.page,
                    total_records: data.total_records,
                    total_pages: data.total_pages,
                    loadingList: false
                });
            } else {
                this.setState({ loadingList: false });
            }
        });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        const errors = this.validateForm();
        if (Object.keys(errors).length > 0) {
            this.setState({ errors });
            return;
        }
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        var formData = {

            company_employee_category: this.state.company_employee_category,
            date: currentDateAndTime()

        }
        if (this.state.company_employee_category_id !== 0) {
            formData.company_employee_category_id = this.state.company_employee_category_id;
        }
        axios
        .post(`${apiURL}Masters/CreateEmployeeCategory`, formData, { headers })
        .then((response) => {
            const { success } = response.data;
            if (success === true) {
                this.resetForm();
                this.setState({ loadingList: true }, () => { this.GetList(); });
            }
            Swal.fire({
                title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                text: response.data.message,
                icon: response.data.success === true ? 'success' : 'error',
                showConfirmButton: true,
                allowOutsideClick: false,
            })
            this.setState({ postLoading: false });
        })
        .catch((error)=>{
            this.setState({ loadingList: false, postLoading: false });
        })
    };
    resetForm = () => {
        this.setState({
            company_employee_category_id: 0,
            company_employee_category: '',
        })

    }

    validateForm = () => {
        const errors = {};

        if (!this.state.company_employee_category) {
            errors.company_employee_category = 'Employee Category is required';
        }

        return errors;
    };


    handleDelete = (id) => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        Swal.fire(
            {
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }
        ).then((result) => {
            if (result.isConfirmed) {
                this.setState({ status: true, loadingDelete: true });
                const formData = {
                    company_employee_category_id: id,
                    date: currentDateAndTime()
                };
                axios
                    .post(`${apiURL}Masters/DeleteEmployeeCategory`, formData, { headers })
                    .then((response) => {
                        Swal.fire({
                            title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                            text: response.data.message,
                            icon: response.data.success === true ? 'success' : 'error',
                            timer: 1000,
                            showConfirmButton: true,
                            allowOutsideClick: false,
                        });
                        this.setState({ status: false, loadingDelete: false });
                        if (response.data.success === true) {
                            this.setState({ loadingList: true }, (prevState) => {
                                this.GetList();
                            })
                        }
                    })
                    .catch((error) => {
                        this.setState({ status: false, loadingDelete: false });
                        Swal.fire({
                            title: <strong>Error</strong>,
                            html: error,
                            icon: 'error'
                        })
                    });
            }
        });
    }

    handlePrev = (ev) => {

        if (this.state.prev === true) {
            this.setState((prevState) => {
                return { page: prevState.page - 1 };
            }, () => {
                this.GetList();
            });
        }
    }
    handleNext = () => {

        if (this.state.next === true) {
            this.setState((prevState) => {
                return { page: prevState.page + 1 };
            }, () => {
                this.GetList();
            });
        }
    }
    handleChange = (e) => {

        this.setState((prevState) => {
            return { page: parseInt(e.target.value, 10) };
        }, () => {
            this.GetList();
        });
    }
    handleLimitChange = (e) => {
        this.setState(
        {
            limit: parseInt(e.target.value, 10),
            page: 1,
        },
        () => {
            this.GetList();
        }
        );
    };
    handleInputSearch = () => {
        this.GetList();
    }
    handleClearAll = () => {
        this.setState({keyword: "",}, () => {this.GetList();});
    };

    render() {
        const { errors } = this.state;
        const limitOptions = [10, 25, 50, 100, 200, 500];
        return (
            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid">
                        <br />
                        <PageTitle title={`Employee Category`} primary={`Home`} />
                        <div className='card'>
                            <div className=" card-body pb-0 align-items-end justify-content-between d-flex">
                                <div className='  '>
                                    <label htmlFor="keyword">Category Title</label>
                                    <div className="input-group">
                                        <input type="search" className="form-control" onChange={this.handleInputChange} name="keyword" value={this.state.keyword} placeholder="Search Category" />
                                        <button className="btn btn-success" onClick={this.handleInputSearch} type="button"><i className="ri-search-line"></i></button>
                                        <button className="btn btn-secondary ms-3" disabled={!this.state.keyword} onClick={this.handleClearAll} type="button">Clear</button>
                                    </div>
                                </div>
                                { this.state.decodedData?.includes(2) && (
                                <div className=''>
                                    <button style={{ float: "right"}} onClick={()=>{ this.setState({ company_employee_category_id:0, isCategoryModal: true }) }} className={`btn btn-success btn-label `} >
                                        <span className="d-flex align-items-center gap-1">
                                        <i className={` ri-play-list-add-line label-icon align-middle fs-16`} />
                                        Add
                                    </span>
                                    </button>
                                </div>)}
                            </div>
                            <div className="card-body">
                                <table style={{ minWidth: '100%',}} className="table table-borderless table-hover align-middle mb-0 table-bordered table-stripped position-relative">
                                    <thead className="bg-primary text-light bg-gradient sticky-top z-1">
                                        <tr>
                                            <th style={{ width: "5%" }} className=' text-center'>Sr.No.</th>
                                            <th>Employee Category Title</th>
                                            <th style={{ width: "10%"}} className=' text-center'>Action</th>
                                        </tr>
                                    </thead>
                                     {this.state.rows?.length === 0 ?
                                        <tbody>
                                            <tr>
                                                <td colSpan={5}>
                                                    <NoRecords />
                                                </td>
                                            </tr>
                                        </tbody>:
                                        <tbody>
                                            {
                                                this.state.rows.map((row,idx) => {
                                                    return <tr key={row.company_employee_category_id}>
                                                        <td className=' text-center'>{idx+1}</td>
                                                        <td>{row.company_employee_category}</td>
                                                        {/* <td className='d-flex justify-content-around'>
                                                            <button type='button' onClick={() => this.GetInfo(row)} className="btn-icon btn btn-sm btn-outline-primary"> <i className="ri-edit-box-line"></i> </button>
                                                            <button onClick={() => this.handleDelete(row.company_employee_category_id)} className="btn-icon btn btn-sm btn-outline-danger"> <i className="ri-delete-bin-line"></i> </button>
                                                        </td> */}
                                                         { (this.state.decodedData?.includes(3) || this.state.decodedData?.includes(4)) && (
                                                        <td className='d-flex justify-content-around'>
                                                            { this.state.decodedData?.includes(3) && (
                                                                <IconButton 
                                                                onClick={() => { this.GetInfo(row); }} type='primary' icon='ri-edit-box-line' tooltipName='Edit' tooltipPosition='bottom' />)}
                                                            { this.state.decodedData?.includes(4) && (
                                                                <IconButton 
                                                                loading={this.state.loadingDelete }
                                                                onClick={() => { this.handleDelete(row.company_employee_category_id); }} type='danger' icon='ri-delete-bin-line' tooltipName='Delete' tooltipPosition='bottom' />)}
                                                        </td>)}
                                                    </tr>
                                                })
                                            }
                                        </tbody>
                                    }

                                </table>
                                <div className="d-flex bg-light justify-content-between align-items-center w-100 py-2 px-2" >
                                    <button disabled={this.state.prev === false && this.state.loadingList === false} name="prev" type="button" onClick={(e) => this.handlePrev("2")} className={`btn btn-warning btn-label waves-effect waves-light`}><i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" /> Previous</button>
                                    <div className='col-md-4' style={{ display: 'flex', alignItems: 'center' }}>
                                        {
                                            <small>Total Records: {this.state.total_records} | Total Pages: {this.state.total_pages} | Current Page: {this.state.page}</small>
                                        }
                                    </div>
                                    <div className='col-md-2'>
                                        <select name="total_pages" className="form-select" onChange={(e) => this.handleChange(e,"2")}>
                                            {Array.from({ length: this.state.total_pages }, (_, i) => (
                                                <option selected={this.state.page === i + 1} key={i} value={i + 1}>Page {i + 1}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-2">
                                        <select className="form-select" onChange={this.handleLimitChange} value={this.state.limit}>
                                            <option value={`${this.state.rows?.length}`}>All</option>
                                            {limitOptions.map((option) => (
                                                <option key={option} value={option}>Limit {option}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <button disabled={this.state.next === false && this.state.loadingList === false} name="next" type="button" onClick={(e) => this.handleNext("2")} className={`btn btn-primary btn-label waves-effect right waves-light`}><i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" /> Next</button>
                                </div>
                            </div>
                            {this.state.isCategoryModal && (
                                <div className="modal show" style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)", }}>
                                    <div className="m-auto mt-3 w-modal">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title">Category</h5>
                                            <button disabled={this.state.postLoading} onClick={() => { if(!this.state.postLoading){ this.setState({ isCategoryModal:!this.state.isCategoryModal },()=> this.resetForm()) } }} className="btn-close" aria-label="Close"/>
                                        </div>
                                        <div className="modal-body pt-0">
                                            <form className="row">
                                                <div className="col-md-12">
                                                    <label htmlFor="company_employee_category" className="form-label">Employee Category Title</label>
                                                    <input
                                                        type='text'
                                                        id='company_employee_category'
                                                        name='company_employee_category'
                                                        value={this.state.company_employee_category}
                                                        disabled={(!this.state.decodedData?.includes(2) && !this.state.decodedData?.includes(3))}
                                                        className={`form-control ${errors.company_employee_category ? 'is-invalid' : ''}`}
                                                        placeholder='Enter Category Title'
                                                        onChange={this.handleInputChange}
                                                    />
                                                    {errors.company_employee_category && <div className="invalid-feedback">{errors.company_employee_category}</div>}
                                                </div>
                                                { (this.state.decodedData?.includes(2) || this.state.decodedData?.includes(3)) && (
                                                <div className="col-md-12" style={{ marginTop: "30px" }}>
                                                    {
                                                        // this.state.company_employee_category_id !== 0 ? <SubmitBtn icon={`ri-save-line`} text={`Update`} type={`primary`} status={this.state.status} /> : <SubmitBtn text={`Save`} type={`primary`} icon={`ri-save-line`} />
                                                        !this.state.decodedData?.includes(2) && this.state.decodedData?.includes(3)  ? (
                                                            <SubmitButton onClick={(e)=>{ 
                                                                this.setState({postLoading:true},()=>this.handleSubmit(e));
                                                            }}
                                                            disabled={!this.state.company_employee_category_id}
                                                            loading={this.state.postLoading} loadingMessage='Loading'
                                                            buttonName={'Update'} icon={'ri-save-line'} 
                                                            type='primary' iconSide='left' />) : (
                                                            <SubmitButton onClick={(e)=>{ 
                                                                this.setState({postLoading:true},()=>this.handleSubmit(e));
                                                            }}
                                                            loading={this.state.postLoading} loadingMessage='Loading'
                                                            buttonName={this.state.company_employee_category_id ? 'Update':'Save'} icon={'ri-save-line'} 
                                                            type='primary' iconSide='left' />)
                                                    }
                                                </div>)}
                                            </form>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        )
    };
}
export default withRouter(EmployeeCategory);



